<template>
  <div class="echart-container">
    <div class="time-line flex-center">
      <!-- <div class="tab">{{i18n.t('chart_page.time')}}</div> -->
      <div class="tab" v-for="(item, i) in showTimeList" :key="i" :class="echartsTime == item.time ? 'active' : ''" @click="changeTime(item)">
        {{item.text}}
      </div>
      <div class="tab flex-center more" @click="showMoreBox">
        <span :class="echartsTimeName ? 'high' : ''">{{echartsTimeName || i18n.t('chart_page.label2')}}</span>
        <img :src="downUrl" alt=""  :class="showMore ? 'show' : ''">
      </div>

    </div>

    <div class="echart-dom" id="echartDom" ></div>

    <Popup v-model="showMore" class="" position="bottom">
      <div class="more-line-box ">
        <div class="more-title"> {{$t('trade.label62')}}</div>
        <div class="time-box flex-wrap">
          <div class="tab" v-for="(item, i) in timeList" :key="i" :class="echartsTime == item.time ? 'active' : ''" @click="changeTime(item, true)">
            {{item.text}}
          </div>
        </div>
      </div>
    </Popup>
  </div>
</template>
<script>
import { Popup } from 'vant'
import * as echarts from 'echarts'
import { kLine } from '@/api/trade'
export default {
  components: {
    Popup
  },
  data() {
    return {
      downUrl: require('../../assets/imgs/icon-arrow-down4.png'),
      leftArrow: require('../../assets/imgs/char-line.png'),
      timeIndex: 0,
      showMore: false,
      echartsTime: 'm1',
      echartsTimeName: '',
      timeList: [
        {
          time: 'm1',
          text: this.i18n.t('chart_page.time1')
        },
        {
          time: 'm3',
          text: this.i18n.t('chart_page.time2')
        },
        {
          time: 'm5',
          text: this.i18n.t('chart_page.time3')
        },
        {
          time: 'm15',
          text: this.i18n.t('chart_page.time4')
        },
        {
          time: 'm30',
          text: this.i18n.t('chart_page.time5')
        },
        {
          time: 'h1',
          text: this.i18n.t('chart_page.time6')
        },
        // {
        //   time: 'h2',
        //   text: this.i18n.t('chart_page.time7')
        // },
        // {
        //   time: 'h4',
        //   text: this.i18n.t('chart_page.time8')
        // },
        // {
        //   time: 'h6',
        //   text: this.i18n.t('chart_page.time9')
        // },
        // {
        //   time: 'h12',
        //   text: this.i18n.t('chart_page.time10')
        // },
        // {
        //   time: 'd1',
        //   text: this.i18n.t('chart_page.time11')
        // },
      ],
      showTimeList: [],
      moreTimeList: [],
      xDataList: [],
      startValue: 0,
      endValue: 29,
      isMaxLeft: true,
      isMinLeft: true,
      kLineData: [],
      dataBak: [],
      echartsObj: null,
      timer: '',
      isLoading: false,
      lastPrice: 0 // A. add lastPrice state
    }
  },
  props: {
    id: [String, Number],
    showChart: Boolean
  },
  watch: {
    id(val) {
      if (val && !this.isLoading) {
        this.init()
      }
    },
    showChart(val) {
      if (val && !this.isLoading) {
        this.$nextTick(() => {
          this.init()
        }, 100)
      }
    }
  },
  mounted() {
    this.showTimeList = this.timeList.slice(0, 5)
    this.moreTimeList = this.timeList.slice(5)
    if (this.id) {
      this.init()
    }
    let dom = document.getElementById('echartDom')
    if (dom) {
      dom.addEventListener('touchend', this.hideTooltip)
    }
  },
  methods: {
    init() {
      this.isLoading = true
      let form = new FormData()
      form.append('CurrencyId', this.id)
      form.append('Count', 1000)
      form.append('TimeLine', this.echartsTime)
      kLine(form).then(res => {
        this.isLoading = false
        const moment = require('moment-timezone');
        const serverTimezone = this.$store.state.timeZone;
        // 进行时间格式化
        res.data.forEach(v => {
            v.CreatedAt = moment.tz(v.CreatedAt, serverTimezone).format('MM-DD HH:mm');
            v.UpdatedAt = moment.tz(v.UpdatedAt, serverTimezone).format('MM-DD HH:mm');
        })
        this.kLineData = res.data
        if (this.showChart) {
          this.initChart()
        }
      })
    },
    initChart() {
      var echartsObj = null
      if (this.echartsObj) {
        echartsObj = this.echartsObj
      } else {
        echartsObj = echarts.init(document.getElementById('echartDom'));
      }

      let data = this.kLineData.map(v => {
        return [v.Open, v.Close, v.Low, v.High]
      })
      this.xDataList = this.kLineData.map(v => {
        return v.UpdatedAt
      })
      this.dataBak = [].concat(data)

      data.reverse()
      this.dataBak = data
      this.xDataList.reverse()
      this.startValue = data.length - 30
      this.startValue = data.length - 30
      this.endValue = data.length - 1
      // Initialize internal lastPrice if data exists
      if (data.length > 0) {
        this.lastPrice = parseFloat(data[data.length - 1][1]);
      }
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            z: 10,
            crossStyle: {
              // color: '#F7A600'
            }
          },
          backgroundColor: 'rgba(0, 0, 0, .7)',
          textStyle: {
            color: '#919eae'
          },
          borderWidth: 1,
          borderColor: '#919eae',
          formatter: (params) => {
            // let index = data.length - params[0].dataIndex - 1
            let index = params[0].dataIndex
            let day = this.kLineData[index].UpdatedAt.substring(11)
            let open = parseFloat(data[index][0])
            let close = parseFloat(data[index][1])
            let low = parseFloat(data[index][2])
            let high = parseFloat(data[index][3])
            let vol = parseFloat(parseFloat(this.kLineData[index].Volume).toFixed(4))
            let result = '<span class="chart-tooltip "><span>' + this.i18n.t('chart_page.time') + '</span>' + day + '</span>' +
                          '<span class="chart-tooltip "><span>' + this.i18n.t('chart_page.open') + '</span>' + open + '</span>' +
                          '<span class="chart-tooltip "><span>' + this.i18n.t('chart_page.high') + '</span>' + high + '</span>' +
                          '<span class="chart-tooltip "><span>' + this.i18n.t('chart_page.low') + '</span>' + low + '</span>' +
                          '<span class="chart-tooltip "><span>' + this.i18n.t('chart_page.close') + '</span>' + close + '</span>'+
                          '<span class="chart-tooltip "><span>' + this.i18n.t('chart_page.vol') + '</span>' + vol + '</span>'
            return result
          }
        },
        grid: {
          top: 30,
          left: 0,
          right: 60,
          bottom: 20,
          containLabel: false
        },
        xAxis: {
          type: 'category',
          data: this.xDataList,
          boundaryGap: false,
          splitLine: { show: false },
          axisLine: {
            onZero: false,
            show: false,
            lineStyle: {
              // color: '#202123',
              width: 1
            }
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: '#ADB1B8'
          },
          min: 'dataMin',
          max: 'dataMax'
        },
        yAxis: {
          position: 'right',
          scale: true,
          axisLabel: {
            show: true,
            color: '#ADB1B8',
            inside: false,
            margin: 4
          },
          splitLine: {
            lineStyle: {
              color: '#F8F9FA',
              width: 1
            }
          }
        },
        dataZoom: [
          {
            type: 'inside',
            filterMode: 'filter',
            startValue: this.startValue,
            endValue: this.endValue
          },
        ],
        series: this.getSerie(data)
      };
      // console.log("this.resetDataZoom")
      echartsObj.on('dataZoom', this.resetDataZoom);
      // echartsObj.on('mouseup', this.hideTooltip);
      echartsObj.setOption(option)
      this.echartsObj = echartsObj
    },
    changeTime(data, isMore) {
      this.echartsTime = data.time
      if (isMore) {
        this.showMore = false
        this.echartsTimeName = data.text
      } else {
        this.echartsTimeName = ''
      }
      this.init()
    },
    showMoreBox() {
      this.showMore = !this.showMore
    },
    cancelHide() {
      clearTimeout(this.timer)
    },
    hideTooltip() {
      this.timer = setTimeout(() => {
        this.echartsObj.dispatchAction({
          type: 'hideTip',
        })
        this.echartsObj.dispatchAction({
          type: 'updateAxisPointer',
          currTrigger: 'leave'
        })
      }, 2000)
    },
    resetDataZoom(e) {
      let start = e.batch[0].start
      let end = e.batch[0].end
      let index = this.xDataList.length - 1
      let startIndex = Math.round(start * index / 100)
      let endIndex = Math.round(end * index / 100)

      let maxVal = 0
      let minVal = 10000000
      let data = this.dataBak.slice(startIndex, endIndex)

      data.forEach(v => {
        if (v[3] > maxVal) {
          maxVal = v[3]
        }
        if (v[2] < minVal) {
          minVal = v[2]
        }
      })

      let maxIndex = data.findIndex(v => {
        return v[3] == maxVal
      })
      let minIndex = data.findIndex(v => {
        return v[2] == minVal
      })

      maxIndex += startIndex
      minIndex += startIndex

      let isMaxLeft =  maxIndex < (startIndex + endIndex) / 2
      let isMinLeft =  minIndex < (startIndex + endIndex) / 2

      let series = null
      if (this.isMinLeft != isMinLeft || this.isMaxLeft != isMaxLeft) {
        series = this.getSerie(this.dataBak)
        this.isMinLeft = isMinLeft
        this.isMaxLeft = isMaxLeft
        let option = {
          series
        }
        this.echartsObj.setOption(option)
      }
    },
    getSerie(data) {
      let markLine = {};
      if (this.lastPrice) {
        markLine = {
            symbol: ['none', 'none'],
            z: 100,
            data: [
              {
                yAxis: this.lastPrice,
                label: {
                  show: true,
                  position: 'end',
                  align: 'right',
                  offset: [60, 0],
                  formatter: (p) => {
                    return p.value;
                  },
                  backgroundColor: '#F7A600',
                  color: '#fff',
                  padding: [2, 10],
                  borderRadius: 2
                },
                lineStyle: {
                  type: 'dashed',
                  color: '#F7A600',
                  width: 1,
                  opacity: 0.8
                }
              }
            ],
            animation: false
        }
      }

      return [
        {
          type: 'candlestick',
          zlevel: 1,
          z: 101,
          itemStyle: {
            color: '#20B26C',
            color0: '#EF454A',
            borderColor: '#20B26C',
            borderColor0: '#EF454A',
          },
          barMaxWidth: 10,
          data: data,
          markPoint: {
            data: [
              {
                silent: true,
                name: 'highest value',
                type: 'max',
                valueDim: 'highest',
                symbol: 'image://' + this.leftArrow,
                symbolSize: [40, 1],
                symbolOffset: this.isMaxLeft ? [20, 0] : [-20, 0],
                label: {
                  color: '#fff',
                  show: true,
                  fontSize: 10,
                  position: this.isMaxLeft ? 'right' : 'left'
                }
              },
              {
                silent: true,
                name: 'lowest value',
                type: 'min',
                valueDim: 'lowest',
                symbol: 'image://' + this.leftArrow,
                symbolSize: [40, 1],
                symbolOffset: this.isMinLeft ? [20, 0] : [-20, 0],
                label: {
                  color: '#fff',
                  show: true,
                  fontSize: 10,
                  position: this.isMinLeft ? 'right' : 'left'
                }
              },
            ],
            tooltip: {
              formatter: function (param) {
                return param.name + '<br>' + (param.data.coord || '');
              }
            }
          },
          markLine: markLine,
        }
      ]
    },
    // A. Update Latest Price Line
    updateLastPriceLine(price) {
      this.lastPrice = price
      if (this.echartsObj) {
        this.echartsObj.setOption({
          series: [
            {
               markLine: {
                symbol: ['none', 'none'],
                z: 100,
                data: [
                  {
                    yAxis: this.lastPrice,
                     label: {
                      show: true,
                      position: 'end',
                      align: 'right',
                      offset: [60, 0],
                      formatter: (p) => {
                        return p.value;
                      },
                      backgroundColor: '#F7A600',
                      color: '#fff',
                      padding: [2, 10],
                      borderRadius: 2
                    },
                    lineStyle: {
                      type: 'dashed',
                      color: '#F7A600',
                      width: 1,
                      opacity: 0.8
                    }
                  }
                ],
                animation: false
              }
            }
          ]
        })
      }
    },
    // B. Real-time K-line Drawing (Streaming)
    updateStreamingBar(bar) {
        if (!this.kLineData.length || !this.echartsObj) return

        const moment = require('moment-timezone');
        const serverTimezone = this.$store.state.timeZone;
        // Use the same format as init()
        let timeStr = moment.tz(bar.Time, serverTimezone).format('MM-DD HH:mm');
        
        let lastIndex = this.kLineData.length - 1
        let lastTimeStr = this.xDataList[lastIndex]


        let isNew = false
        // 1) Current candle update
        if (timeStr === lastTimeStr) {
             let item = this.kLineData[lastIndex]
             this.kLineData.splice(lastIndex, 1, { ...item, ...bar, UpdatedAt: timeStr })
             this.dataBak.splice(lastIndex, 1, [bar.Open, bar.Close, bar.Low, bar.High])
        } else {
             // 2) New candle push
             isNew = true
             this.kLineData.push({ ...bar, UpdatedAt: timeStr })
             this.dataBak.push([bar.Open, bar.Close, bar.Low, bar.High])
             this.xDataList.push(timeStr)
        }
        
        // Partial Update
        let option = {
            series: [
                {
                    data: this.dataBak
                }
            ],
             xAxis: {
                data: this.xDataList
            }
        }
        
        // Follow Latest Strategy
        let zoom = this.echartsObj.getOption().dataZoom[0]
        if (isNew) {
             if (zoom.end >= 99) { 
                 this.startValue++
                 this.endValue++
                 option.dataZoom = [{
                     startValue: this.startValue,
                     endValue: this.endValue
                 }]
             }
        }
        
        this.echartsObj.setOption(option)
    }
  }
}
</script>